export { BugsnagAdapter } from "./BugsnagAdapter";
